<template lang="pug">
div.start-again(@click="emitClick()") ❮ 
    span {{ $t('startAgain.button') }}
</template>
<script lang="ts">
import { LayoutEvent, emit } from "@/helpers";
import { defineComponent } from "vue";
export default defineComponent({
  name: "StartAgainButton",
  setup() {
    function emitClick() {
      emit(LayoutEvent.StartAgainClicked, {});
    }
    return {
      emitClick,
    };
  },
});
</script>
<style scoped lang="scss">
.start-again {
  text-decoration: none;
  cursor: pointer;
  width: fit-content;
  span {
    margin-left: 0.25rem;
    padding-bottom: 0.25rem;
  }
}
</style>
